import * as React from "react";
import autobind from "class-autobind";
import Dropzone from "react-dropzone";
import { FaTimes, FaUpload } from "react-icons/fa";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";
import { withTranslation, WithTranslation } from "react-i18next";

interface Props extends WithTranslation {
  accept?: string;
  onChange: (files: File[]) => void;
  maxFiles?: number;
  maxSizeMegaBytes?: number;
  files: File[];
}

interface Injected extends Props {}

interface State {
  error: string;
}

const Wrapper = styled("div")`
  ${BaseInputCSS};
  border-style: dashed;
  height: auto;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 20px;
  cursor: pointer;
  p {
    font-size: 14px;
  }
  h4 {
    font-size: 18px;
  }
`;
const WrapperInner = styled("div")`
  text-align: center;
`;

class FormDropzoneClass extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      error: "",
    };
  }

  onDrop(files: File[]) {

    const { t, onChange, maxFiles, maxSizeMegaBytes } = this.props as Injected;

    if (maxFiles !== undefined && files.length > maxFiles) {
      this.setState({
        error: t("components.field.dropzone.errors.max_files", { number: maxFiles }),
      });
      return;
    }

    if (maxSizeMegaBytes !== undefined) {
      for (const file of files) {
        if ((file.size / 1024 / 1024) > maxSizeMegaBytes) {
          this.setState({
            error: t("components.field.dropzone.errors.max_size", { kilobytes: Math.round(maxSizeMegaBytes * 1000) }),
          });
          return;
        }
      }
    }

    onChange(files);

    this.setState({ error: "" });

  }

  remove(e: React.MouseEvent<HTMLAnchorElement>) {
    e.stopPropagation();
    this.props.onChange([]);
  }

  render() {
    const { error } = this.state;
    const { t, files, accept } = this.props as Injected;
    return (
      <Dropzone accept={accept || "image/jpeg, image/png"} onDrop={this.onDrop} className="width100">
        <Wrapper>
          <WrapperInner>
            { files.length !== 0 &&
              <div>
                <a onClick={this.remove} className="block">
                  <h4><FaTimes className="m-r-2"/>{t("components.field.dropzone.remove")}</h4>
                </a>
                {files.map((f, i) => (
                  <p key={i} className="m-t-2">{f.name}</p>
                ))}
              </div>
            }
            { files.length === 0 &&
            <div>
              <h4 className="m-b-2"><FaUpload/></h4>
              <p>{t("components.field.dropzone.drop_here")}</p>
              <p className="m-t-1">{t("components.field.dropzone.accepts", { fileTypes: accept || "image/jpeg, image/png"})}</p>
            </div>
            }
            {error && (
              <div className="error-text m-t-2">
                <p className="font-semi-bold underline">{error}</p>
              </div>
            )}
          </WrapperInner>
        </Wrapper>
      </Dropzone>
    );
  }
}

export const FormDropzone = withTranslation()(FormDropzoneClass);
